import { gql } from "@/gql";

export const CUSTOMER_ANALYTICS_QUERY = gql(`
  query CustomerAnalytics($customerId: String!) {
    customerAnalytics(customerId: $customerId) {
      customerId
      lastUpdated
      lifetimeValue {
        customerId
        lifetimeValue
        totalVisits
        avgSpendPerVisit
        lastVisitDate
        firstVisitDate
        spendingTrendPercent
        spendingTrendDirection
      }
      visitFrequency {
        customerId
        avgDaysBetweenVisits
        totalVisits
        minDaysBetween
        maxDaysBetween
        visitConsistency
        daysSinceLastVisit
        predictedNextVisit
      }
      servicePreferences {
        serviceName
        serviceCategoryName
        bookingCount
        totalSpent
        avgPrice
        lastBooked
        percentageOfVisits
        daysSinceLastBooked
        usageFrequency
        loyaltyLevel
      }
      staffPreferences {
        workerId
        workerName
        firstName
        lastName
        bookingCount
        totalSpent
        avgSpentPerVisit
        lastBookedWith
        percentageOfVisits
        daysSinceLastVisit
        relationshipStrength
        isPreferredStaff
      }
      churnRisk {
        customerId
        churnRiskLevel
        totalRiskScore
        daysSinceLastVisit
        avgDaysBetween
        overdueDays
        recommendedAction
      }
      seasonalPatterns {
        customerId
        peakMonth
        peakDayOfWeek
        seasonalityScore
        monthlyTrends {
          month
          year
          visitCount
          totalSpent
          avgSpentPerVisit
          monthName
        }
        dayOfWeekPatterns {
          dayOfWeek
          dayName
          visitCount
          totalSpent
          avgSpentPerVisit
          percentageOfVisits
        }
      }
      predictiveInsights {
        customerId
        lastUpdated
        nextVisit {
          predictedDate
          daysFromNow
          confidence
          probabilityPercentage
          reasoning
        }
        lifetimeValueForecast {
          currentLifetimeValue
          predicted6MonthValue
          predicted12MonthValue
          growthRate
          confidence
          trendDirection
        }
        churnPrediction {
          currentRiskLevel
          churnProbability
          daysUntilLikelyChurn
          confidence
          riskFactors
          preventionStrategies
        }
      }
    }
  }
`);

export const INVALIDATE_CUSTOMER_ANALYTICS_CACHE_MUTATION = gql(`
  mutation InvalidateCustomerAnalyticsCache($customerId: String!) {
    invalidateCustomerAnalyticsCache(customerId: $customerId)
  }
`);
